import { ComponentQrcodePainsItems, Qrcode } from '@/typings/types';
import { SectionTitle } from '@/common/titles';
import ProductsList from '@/components/qrcode/products';

type OthersProps = {
  others: Qrcode['painepices'] | Qrcode['brioches'];
};

const Others = ({ others }: OthersProps) => {
  const { title, subtitle, items } = others ?? {};
  return (
    <section className={'flex flex-col justify-start max-w-6xl mb-20 lg:mb-10'}>
      {title && <SectionTitle title={title} subtitle={subtitle} />}
      <div className={'flex flex-col'}>
        <ProductsList items={items as ComponentQrcodePainsItems[]} />
      </div>
    </section>
  );
};

export default Others;
